import "../styles/stats.css";
import { motion } from "framer-motion";
import StatsArrow from "../assets/Cool Arrows/Layer 1.png";

const statsList = [
  {
    kicker: "Acaboom — PropTech",
    value: "£280k",
    copy:
      "Average annual return on a £40k marketing budget. £7 for every £1 spent. Full marketing management, campaigns, branding and email strategy — sole responsibility.",
  },
  {
    kicker: "Gaps LTD — Aerospace & Automotive",
    value: "£637k",
    copy:
      "In booked business from a targeted email + direct mail campaign costing just £1,250. 7 meetings booked in one month on one of the strongest clients converted.",
  },
  {
    kicker: "Collection Pot — Fintech",
    value: "2,963%",
    copy:
      "More traffic than their homepage. A single blog post gets 15,000 visits per month — outperforming PPC and all other marketing channels. Blog traffic: 19,633 vs homepage: 641.",
  },
  {
    kicker: "The Access Group — PeopleHR",
    value: "1,500+",
    copy:
      "Monthly visits to my top-performing content pieces. ‘What Is Toll’ alone gets 1,405 visits/month. Homepage gets 8,542 — for context. Two landing pages also drive hundreds of monthly visits each.",
  },
  {
    kicker: "Acaboom — Email Campaigns",
    value: "£86,801",
    copy:
      "£86,801 of the £280k came from 40+ email campaigns to media houses and the company’s own database. £35,370 from a single white paper outreach sequence. £24,258 from solo campaigns alone.",
  },
  {
    kicker: "Kolekti — Part of Atlassian",
    value: "9,000",
    copy:
      "Monthly visitors driven largely by my blog content. ‘What is collaborative teamwork?’ ranks 6th. ‘What is documentation?’ ranks 8th. Position 5 on Google for core head terms.",
  },
  {
    kicker: "Moxiworks — proptech",
    value: "Page 1",
    copy:
      "Average Google rankings achieved for multiple commercial keywords, including #4.1, #5.5 and #6.0, alongside 216k+ impressions for real estate marketing content and 165k+ impressions for real estate lead generation content."
  },  
  {
    kicker: "Activepipe — proptech",
    value: "15k+",
    copy:
    "Google Search impressions for social media marketing content, alongside first-page rankings for commercial real estate marketing topics including Lead Scoring for Real Estate (#7) and Facebook Marketing (#12.1). Produced SEO content supporting enterprise real estate marketing across Australia and New Zealand."
  },

];

const StatCard = ({ stat, index }) => {
  const cardViewport = {
    once: true,
    amount: 0.35,
    margin: "0px 0px -15% 0px",
  };

  return (
    <motion.article
      className="stat-card"
      initial={{ opacity: 0, y: 20 }}
      whileInView={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.7, delay: 0.08 + index * 0.08, ease: "easeOut" }}
      viewport={cardViewport}
    >
      <p className="stat-card__kicker">{stat.kicker}</p>
      <h2 className="stat-card__value">{stat.value}</h2>
      <p className="stat-card__copy">{stat.copy}</p>
    </motion.article>
  );
};

const Stats = () => {
  const sectionViewport = {
    once: true,
    amount: 0.35,
    margin: "0px 0px -15% 0px",
  };

  const fadeInUp = {
    hidden: { opacity: 0, y: 22 },
    visible: (i = 0) => ({
      opacity: 1,
      y: 0,
      transition: { delay: 0.08 + i * 0.12, duration: 0.7, ease: "easeOut" },
    }),
  };

  return (
    <section id="stats" aria-label="Marketing stats and results">
      <motion.img
        className="home-decor-arrow home-decor-arrow--stats-2"
        src={StatsArrow}
        alt=""
        aria-hidden="true"
        loading="lazy"
        decoding="async"
        variants={fadeInUp}
        initial="hidden"
        whileInView="visible"
        custom={0}
        delay={0.8}
        viewport={sectionViewport}
      />
      <motion.img
        className="home-decor-arrow home-decor-arrow--stats"
        src={StatsArrow}
        alt=""
        aria-hidden="true"
        loading="lazy"
        decoding="async"
        variants={fadeInUp}
        initial="hidden"
        whileInView="visible"
        custom={0}
        delay={0.6}
        viewport={sectionViewport}
      />

      <motion.h1
        className="main-text"
        variants={fadeInUp}
        initial="hidden"
        whileInView="visible"
        custom={1}
        viewport={sectionViewport}
      >
        What I Can Do
      </motion.h1>
      <motion.p
        className="sub-text"
        variants={fadeInUp}
        initial="hidden"
        whileInView="visible"
        custom={2}
        viewport={sectionViewport}
      >
        A snapshot of the outcomes behind the campaigns, content, and strategy.
      </motion.p>
      <div className="stats-grid">
        {statsList.map((stat, index) => (
          <StatCard key={`${stat.kicker}-${index}`} stat={stat} index={index} />
        ))}
      </div>
    </section>
  );
};

export default Stats;